import { TextField } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import React from 'react';
import { useI18n } from '../../../../i18n/I18n';
import { Icons } from '../../../../icons/Icons';

type NotesSearchInputProps = {
    id: string;
    value: string;
    onChange: (value: string) => void;
};

const buttonSx: SxProps<Theme> = (theme) => ({
    ml: 1,
    '&:hover': { cursor: 'pointer' },
    color: theme.palette.text.primary
});

export default function NotesSearchInput({ id, value, onChange }: NotesSearchInputProps) {
    const searchLabel = useI18n('notes.search');

    return (
        <TextField
            id={`${id}-input`}
            sx={{ mb: 1, mt: 0.5 }}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
            variant="outlined"
            fullWidth
            size={'small'}
            InputProps={{
                endAdornment: (
                    <>
                        {value && value.length && (
                            <Icons.Close
                                sx={buttonSx}
                                onClick={() => {
                                    onChange('');
                                }}
                            />
                        )}
                        <Icons.Search sx={buttonSx} />
                    </>
                ),
                inputProps: {
                    placeholder: searchLabel
                }
            }}
        />
    );
}
